import FilterSectionWrapper from './FilterSectionWrapper';

export default FilterSectionWrapper;
